<template>
    <div class="list-group-item account-item text-body" :class="classes" v-bind="attributes" @click="handleClicked">
        <div class="row" style="--bs-gutter-x: .75rem">
            <template v-if="selectable">
                <div class="col-auto">
                    <div class="custom-control custom-radio">
                        <input
                            class="custom-control-input"
                            name="account_id"
                            type="radio"
                            :value="account.id"
                            :aria-labelledby="id"
                            :checked="isSelected"
                            @change="handleChanged"
                        >
                        <div class="custom-control-label"></div>
                    </div>
                </div>
            </template>
            <div class="col">
                <template v-if="account">
                    <div :id="id">
                        <template v-if="account.is_organization">
                            <h5 class="font-weight-bold mb-1" style="font-size: 1rem">
                                {{ account.organization_name }}
                            </h5>
                        </template>

                        <template v-if="username">
                            <div>
                                {{ username }}
                            </div>
                        </template>

                        <div class="small">
                            <template v-if="account.is_organization">
                                {{ account.organization_position }} / {{ account.organization_service }}
                            </template>
                            <template v-else>
                                {{ account.personal_occupation }}
                            </template>
                        </div>

                        <div class="small">
                            {{ account.address.street }} {{ account.address.postal_code }} {{ account.address.city }}
                        </div>

                        <div class="small">
                            {{ account.address.country }}
                        </div>
                    </div>
                </template>
            </div>
            <template v-if="$slots.append">
                <div class="col-auto">
                    <slot name="append" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            account: Object,
            value: Number,
            username: String,
            selectable: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            id() {
                return `account-${this.account.id}`;
            },
            isSelected() {
                return this.account.id === this.value;
            },
            classes() {
                return {
                    'list-group-item-action': this.selectable,
                }
            },
            attributes() {
                if(!this.selectable) {
                    return {}
                }
                return {
                    'role': 'button',
                    'tabindex': -1,
                }
            },
        },
        methods: {
            handleClicked() {
                this.$emit('input', this.account.id);
                this.$emit('click');
            },
            handleChanged(e) {
                if(e.target.checked) {
                    this.$emit('input', this.account.id);
                }
            },
        },
    }
</script>
